import React, { Component } from "react";
import {
	View,
	Text,
	TouchableOpacity,
	StyleSheet,
	Platform,
} from "react-native";

import * as x from "../../styles/css";

class TextLink extends Component {
	render() {
		return (
			<View style={[x.flexDirection.column]}>
				<TouchableOpacity
					style={[x.my.one]}
					onPress={this.props.onPress}
				>
					<Text
						style={{
							fontSize: this.props.fontSize,
							color: x.colors.default,
							textAlign: this.props.textAlign,
						}}
					>
						{this.props.title}
					</Text>
				</TouchableOpacity>
			</View>
		);
	}
}

TextLink.defaultProps = {
	fontSize: 16,
	textAlign: "left",
};

export default TextLink;



// WEBPACK FOOTER //
// ./src/components/TextLink/index.js